import { render, staticRenderFns } from "./detailsTirdFactorySupplyList.vue?vue&type=template&id=c0742706"
import script from "./detailsTirdFactorySupplyList.vue?vue&type=script&lang=js"
export * from "./detailsTirdFactorySupplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports